import { Grid, Typography } from "@mui/material"
import { UnauthorizedPage } from "../../pages/Error/ErrorUnauthorized"
import { ExpansiblePanelPI } from "../Common/ExpansiblePanel";

interface Props{
    urlDashboard: string,
    titulo: string,
    autorizado: boolean,
    usuario: string,
    nombres: string;
    apellidos: string;
}

export const GeneralPowerBIComp: React.FC<Props> = ({urlDashboard,titulo, autorizado, usuario, nombres, apellidos}) => {
    return (
        <>
        {autorizado ?
            <>
            <Typography variant="h5" gutterBottom>
            <Grid container spacing={2}>
                <Grid item xs={10} sm={10} md={10} lg={10}>
                    {titulo}
                </Grid>
                <Grid item xs={2} sm={2} md={2} lg={2}>
                </Grid>         
            </Grid>
            </Typography>
            <ExpansiblePanelPI title="Antes de iniciar sesión" nombres={nombres} apellidos={apellidos} usuario={usuario} />
            <Grid container spacing={2} sx={{p:1}}>
                <Grid item xs={12} sm={12} md={12} lg={12}>
                    <iframe
                    title={titulo} 
                    style={{ width: '100%', height: '700px', border: 'none' }} 
                    src={urlDashboard}>
                    </iframe>
                </Grid>
            </Grid>
            </>
            :
            <UnauthorizedPage />
        }
        </>
    )
}